<template>
  <div 
    class="mt-8 px-5">
    <v-dialog v-model="dialog.status"
      @keydown.esc="dialog.status = false"
      :fullscreen="dialog.fullscreen"
      width="700"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
        class="pa-8 pt-6">
        <v-card-title 
          class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
          
          Mengubah Status

          <v-spacer/>

          <!-- <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            color="#718EBF">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.status = false; dialog.fullscreen = false; selected.status = [];"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon> -->

          <v-icon 
            @click="dialog.status = false; dialog.fullscreen = false; message.status = ''; message.error = ''"
            class="cursor-pointer"
            size="18"
            color="#000000">
            mdi-close
          </v-icon>
        </v-card-title>
        
        <!-- <v-divider 
          class="mb-2"
          style="border-top: 2px dashed #e0e0e0;"/> -->

        <v-card-text 
          class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
          Apakah Anda yakin mengubah status data menjadi {{ status }} ?

          <!-- <v-autocomplete
            v-if="detail.status === 'pengiriman' || detail.status === 'Set Order'"
            v-model="status"
            :items="['pengiriman','diterima customer']"
            
            label="Pilih Status"
            
            dense
            outlined
            hide-details
            style="width: 100%"
            class="mt-4"
            >
          </v-autocomplete> -->

          <div v-if="detail.status === 'pengiriman' && form.bpb_arr.length > 0">
            <v-card flat style="border-radius: 25px; border: 1px solid #E7E7E7;" class="pb-7 mt-6 mb-5"  v-for="(items, indexs) in form.bpb_arr" :key="indexs">
              <v-card-text>
                <div class="fs-18 input-label mb-8 font-weight-bold pt-2">
                  BPB Ke-{{ indexs+1 }}
                </div>
              <div v-for="(item, index) in items.bpb_detail" :key="index">
                <!-- {{ index+items.bpb_id }} -->
                <!-- <table width="100%" style="border-bottom: thin solid #E6EFF5;">
                  <thead>
                    <tr>
                      <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Nama Barang</th>
                      <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">No. SKU</th>
                      <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Qty</th>
                      <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Qty Lusin</th>
                      <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Qty Dus</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in form.varian_arr" :key="index">
                      <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_varian_name }}</td>
                      <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_varian_sku }}</td>
                      <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_qty_pcs_approved }}</td>
                      <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_qty_lusin_approved }}</td>
                      <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_qty_dus_approved }}</td>
                    </tr>
                  </tbody>
                </table> -->
                <v-card flat class="mb-5" style="background: #718ebf17; border-radius: 15px;">
                  <v-card-text>
                    <div class="fs-16 font-weight-bold label-input">
                      {{ item.varian_name }}
                    </div>
                    <div>
                      <span>Kode SKU</span>: <span>{{ item.varian_sku }}</span>
                    </div>
                    <!-- <div>
                      <span>Harga</span>: <span>{{ item.price | price }}</span>
                    </div> -->

                    <v-row class="pt-3 pb-0">
                      <v-col class="py-0" cols="2">
                        <div 
                          class="fs-15 label-input">
                          Qty yang dikirim
                        </div>
                      </v-col>
                      <v-col class="py-0">
                        <div 
                          class="fs-15 label-input">
                          Qty yang diterima
                        </div>
                      </v-col>
                      <v-col class="py-0">
                        <div 
                          class="fs-15 label-input">
                          Qty yang dikembalikan
                        </div>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col class="py-0" cols="2">
              
                        <div class="fs-19 font-weight-bold label-input mt-3">
                          {{ item.qty_pcs }} Pcs
                        </div>
                      </v-col>
                      <!-- <v-col>
                        <div class="fs-15 label-input">
                          Harga
                        </div>

                        <div class="fs-19 font-weight-bold label-input mt-3">
                          {{ item.price | price }}
                        </div>
                      </v-col> -->

                      <v-col class="py-0">
  
                        <v-currency-field
                          
                          filled
                          rounded
                          dense
                          solo
    
                          color="#718EBF"
                          placeholder="Qty"
                          suffix="pcs"

                          
    
                          v-model="item.qty_pcs_diterima"
                          required
                          style="border-radius: 10px;">
                        </v-currency-field>
                        <!-- <div class="fs-15 label-input">
                          Qty
                        </div>

                        <v-currency-field
                          
                          filled
                          rounded
                          dense
                          solo
    
                          color="#718EBF"
                          placeholder="Qty"

                          
    
                          v-model="item.qty"
                          required
                          style="border-radius: 10px;">
                        </v-currency-field> -->
                      </v-col>
                      <v-col class="py-0">
  
                        <v-currency-field
                          
                          filled
                          rounded
                          dense
                          solo
    
                          color="#718EBF"
                          placeholder="Qty"
                          suffix="pcs"

                          
    
                          v-model="item.qty_pcs_return"
                          required
                          style="border-radius: 10px;">
                        </v-currency-field>
                        <!-- <div class="fs-15 label-input">
                          Qty
                        </div>

                        <v-currency-field
                          
                          filled
                          rounded
                          dense
                          solo
    
                          color="#718EBF"
                          placeholder="Qty"

                          
    
                          v-model="item.qty"
                          required
                          style="border-radius: 10px;">
                        </v-currency-field> -->
                      </v-col>
                      <!-- <v-col class="py-0" cols="3">
                        <ValidationProvider
                          :name="`Qty Pcs ${item.varian_name}`"
                          :rules="`required|max_value:${item.qty_pcs_approve}|min_value:0`" 
                          v-slot="{ errors }">
    
                          <v-currency-field
                          
                            filled
                            rounded
                            dense
                            solo
      
                            color="#718EBF"
                            placeholder="Qty"
                            suffix="pcs"
      
                            :value="item.qty_pcs"
                            :error-messages="errors"
                            required
                            style="border-radius: 10px;">
                          </v-currency-field>
                        </ValidationProvider>
                      </v-col> -->

                      <!-- <v-col>
                        <div class="fs-15 label-input">
                          Harga Beli
                        </div>

                        <v-currency-field
                          
                          filled
                          rounded
                          dense
                          solo
    
                          color="#718EBF"
                          placeholder="Harga Beli"
                          
    
                          v-model="item.harga_beli"
                          required
                          style="border-radius: 10px;">
                        </v-currency-field>
                      </v-col>

                      <v-col>
                        <div class="fs-15 label-input">
                          PPN Beli
                        </div>

                        <v-currency-field
                          
                          filled
                          rounded
                          dense
                          solo
    
                          color="#718EBF"
                          placeholder="PPN Beli"
                          
    
                          v-model="item.ppn_beli"
                          required
                          style="border-radius: 10px;">
                        </v-currency-field>
                      </v-col> -->
                    </v-row>

                    <v-row>
                      <v-col class="py-0" cols="2">
              
                        <div class="fs-19 font-weight-bold label-input mt-3">
                          {{ item.qty_lusin }} Lusin
                        </div>
                      </v-col>
                      <!-- <v-col>
                        <div class="fs-15 label-input">
                          Harga
                        </div>

                        <div class="fs-19 font-weight-bold label-input mt-3">
                          {{ item.price | price }}
                        </div>
                      </v-col> -->

                      <v-col class="py-0">
  
                        <v-currency-field
                          
                          filled
                          rounded
                          dense
                          solo
    
                          color="#718EBF"
                          placeholder="Qty"
                          suffix="lusin"

                          
    
                          v-model="item.qty_lusin_diterima"
                          required
                          style="border-radius: 10px;">
                        </v-currency-field>
                        <!-- <div class="fs-15 label-input">
                          Qty
                        </div>

                        <v-currency-field
                          
                          filled
                          rounded
                          dense
                          solo
    
                          color="#718EBF"
                          placeholder="Qty"

                          
    
                          v-model="item.qty"
                          required
                          style="border-radius: 10px;">
                        </v-currency-field> -->
                      </v-col>
                      <v-col class="py-0">
  
                        <v-currency-field
                          
                          filled
                          rounded
                          dense
                          solo
    
                          color="#718EBF"
                          placeholder="Qty"
                          suffix="lusin"

                          
    
                          v-model="item.qty_lusin_return"
                          required
                          style="border-radius: 10px;">
                        </v-currency-field>
                        <!-- <div class="fs-15 label-input">
                          Qty
                        </div>

                        <v-currency-field
                          
                          filled
                          rounded
                          dense
                          solo
    
                          color="#718EBF"
                          placeholder="Qty"

                          
    
                          v-model="item.qty"
                          required
                          style="border-radius: 10px;">
                        </v-currency-field> -->
                      </v-col>
                      <!-- <v-col class="py-0" cols="3">
                        <ValidationProvider
                          :name="`Qty Pcs ${item.varian_name}`"
                          :rules="`required|max_value:${item.qty_pcs_approve}|min_value:0`" 
                          v-slot="{ errors }">
    
                          <v-currency-field
                          
                            filled
                            rounded
                            dense
                            solo
      
                            color="#718EBF"
                            placeholder="Qty"
                            suffix="pcs"
      
                            :value="item.qty_pcs"
                            :error-messages="errors"
                            required
                            style="border-radius: 10px;">
                          </v-currency-field>
                        </ValidationProvider>
                      </v-col> -->

                      <!-- <v-col>
                        <div class="fs-15 label-input">
                          Harga Beli
                        </div>

                        <v-currency-field
                          
                          filled
                          rounded
                          dense
                          solo
    
                          color="#718EBF"
                          placeholder="Harga Beli"
                          
    
                          v-model="item.harga_beli"
                          required
                          style="border-radius: 10px;">
                        </v-currency-field>
                      </v-col>

                      <v-col>
                        <div class="fs-15 label-input">
                          PPN Beli
                        </div>

                        <v-currency-field
                          
                          filled
                          rounded
                          dense
                          solo
    
                          color="#718EBF"
                          placeholder="PPN Beli"
                          
    
                          v-model="item.ppn_beli"
                          required
                          style="border-radius: 10px;">
                        </v-currency-field>
                      </v-col> -->
                    </v-row>

                    <v-row>
                      <v-col class="py-0" cols="2">
              
                        <div class="fs-19 font-weight-bold label-input mt-3">
                          {{ item.qty_dus }} Dus
                        </div>
                      </v-col>
                      <!-- <v-col>
                        <div class="fs-15 label-input">
                          Harga
                        </div>

                        <div class="fs-19 font-weight-bold label-input mt-3">
                          {{ item.price | price }}
                        </div>
                      </v-col> -->

                      <v-col class="py-0">
  
                        <v-currency-field
                          
                          filled
                          rounded
                          dense
                          solo
    
                          color="#718EBF"
                          placeholder="Qty"
                          suffix="dus"

                          
    
                          v-model="item.qty_dus_diterima"
                          required
                          style="border-radius: 10px;">
                        </v-currency-field>
                        <!-- <div class="fs-15 label-input">
                          Qty
                        </div>

                        <v-currency-field
                          
                          filled
                          rounded
                          dense
                          solo
    
                          color="#718EBF"
                          placeholder="Qty"

                          
    
                          v-model="item.qty"
                          required
                          style="border-radius: 10px;">
                        </v-currency-field> -->
                      </v-col>
                      <v-col class="py-0">
  
                        <v-currency-field
                          
                          filled
                          rounded
                          dense
                          solo
    
                          color="#718EBF"
                          placeholder="Qty"
                          suffix="dus"

                          
    
                          v-model="item.qty_dus_return"
                          required
                          style="border-radius: 10px;">
                        </v-currency-field>
                        <!-- <div class="fs-15 label-input">
                          Qty
                        </div>

                        <v-currency-field
                          
                          filled
                          rounded
                          dense
                          solo
    
                          color="#718EBF"
                          placeholder="Qty"

                          
    
                          v-model="item.qty"
                          required
                          style="border-radius: 10px;">
                        </v-currency-field> -->
                      </v-col>
                      <!-- <v-col class="py-0" cols="3">
                        <ValidationProvider
                          :name="`Qty Pcs ${item.varian_name}`"
                          :rules="`required|max_value:${item.qty_pcs_approve}|min_value:0`" 
                          v-slot="{ errors }">
    
                          <v-currency-field
                          
                            filled
                            rounded
                            dense
                            solo
      
                            color="#718EBF"
                            placeholder="Qty"
                            suffix="pcs"
      
                            :value="item.qty_pcs"
                            :error-messages="errors"
                            required
                            style="border-radius: 10px;">
                          </v-currency-field>
                        </ValidationProvider>
                      </v-col> -->

                      <!-- <v-col>
                        <div class="fs-15 label-input">
                          Harga Beli
                        </div>

                        <v-currency-field
                          
                          filled
                          rounded
                          dense
                          solo
    
                          color="#718EBF"
                          placeholder="Harga Beli"
                          
    
                          v-model="item.harga_beli"
                          required
                          style="border-radius: 10px;">
                        </v-currency-field>
                      </v-col>

                      <v-col>
                        <div class="fs-15 label-input">
                          PPN Beli
                        </div>

                        <v-currency-field
                          
                          filled
                          rounded
                          dense
                          solo
    
                          color="#718EBF"
                          placeholder="PPN Beli"
                          
    
                          v-model="item.ppn_beli"
                          required
                          style="border-radius: 10px;">
                        </v-currency-field>
                      </v-col> -->
                    </v-row>

                  </v-card-text>
                </v-card>
              </div>

            </v-card-text>
          </v-card>
          </div>


          <div v-if="message.error.length > 0"
            class="text-left mt-4">
            <div
              class="error--text d-flex align-start">
              <v-icon size="18" color="red" style="padding-top: 5px;">mdi-alert-circle-outline</v-icon>
              
              <span
                class="ml-1">
                {{ message.error }}
              </span>
            </div>
          </div>
        </v-card-text>


        <!-- <v-divider 
          class="mt-2"
          style="border-top: 2px dashed #e0e0e0;"/> -->

        <v-card-actions
          class="pa-0 pt-4">
          <v-spacer/>

          <v-btn
            rounded
            @click="save()"
            :loading="process.form"
            :disabled="process.form"
            width="190"
            height="45"
            elevation="0"
            color="#1814F3"
            class="fs-16 white--text text-capitalize border-radius">
            Ya, {{ message.status }}
          </v-btn>

          <!-- <v-btn
            rounded
            width="120"
            @click="dialog.status = false; dialog.fullscreen = false; selected.status = [];"
            :disabled="process.status"
            outlined
            class="body-2 font-weight-bold text-capitalize red--text">
            Batal
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.delete"
      @keydown.esc="dialog.delete = false"
      :fullscreen="dialog.fullscreen"
      width="500"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
        class="pa-6 pt-6">
        <v-card-title 
          class="d-flex align-center pa-0 pb-4 text-right popup-header fs-18 font-weight-bold">
          
          Hapus Data

          <v-spacer/>

          <!-- <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            color="#718EBF">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon> -->

          <v-icon 
            @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
            class="cursor-pointer"
            size="18"
            color="#000000">
            mdi-close
          </v-icon>
        </v-card-title>
        
        <!-- <v-divider 
          class="mb-2"
          style="border-top: 2px dashed #e0e0e0;"/> -->

        <v-card-text 
          class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
          Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">BPB</b> yang Anda pilih?

          <div v-if="message.error.length > 0"
            class="text-center mt-4">
            <div
              class="error--text d-flex align-start">
              <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
              
              <span
                class="ml-1">
                {{ message.error }}
              </span>
            </div>
          </div>
        </v-card-text>


        <!-- <v-divider 
          class="mt-2"
          style="border-top: 2px dashed #e0e0e0;"/> -->

        <v-card-actions
          class="pa-0 pt-4">
          <v-spacer/>

          <v-btn
            rounded
            @click="deletes()"
            :loading="process.delete"
            :disabled="process.delete"
            width="190"
            height="45"
            elevation="0"
            color="#1814F3"
            class="fs-16 white--text text-capitalize border-radius">
            Ya, Hapus
          </v-btn>

          <!-- <v-btn
            rounded
            width="120"
            @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
            :disabled="process.delete"
            outlined
            class="body-2 font-weight-bold text-capitalize red--text">
            Batal
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="dialog.snackbar"
      top
      right
      color="green">
      <span 
        class="body-1 font-weight-light white--text"
        v-html="message.success">
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          icon
          color="white"
          class="body-1 font-weight-bold text-capitalize"
          v-bind="attrs"
          @click="dialog.snackbar = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <v-layout wrap>
      <v-flex>
        <section>
          <v-card 
            flat
            style="border-radius: 6px;"
            background-color="#fff">
            <v-card-text>
              <v-row
                class="mt-0">
                <v-col 
                  cols="12"
                  class="py-0">
                  <v-card 
                    flat>
                    <v-card-text
                      v-if="process.load" 
                      class="pb-0 my-4" style="height: 500px; display: flex; align-items: center; justify-content: center;">
                      <div class="text-center">
                        <div class="mb-2 title">
                          Mohon Tunggu...
                        </div>
                        <v-progress-circular
                          indeterminate
                        ></v-progress-circular>
                      </div>
                    </v-card-text>
    
                    <v-card-text v-if="!process.load && Object.keys(detail).length > 0" class="pa-0">
              
                      <div class="black--text fs-18 font-weight-bold mb-6">
                        Detail Proses Muat
                      </div>
    
                      <v-row>
                        <v-col cols="3">
                          <div>
                            <div class="fs-14" style="margin-bottom: 1px;">
                              No. Surat Jalan
                            </div>
                            <div class="fs-16 label-input font-weight-bold">
                              {{ detail.number }}
                            </div>
                          </div>
                        </v-col>
                        <v-col cols="2">
                          <div>
                            <div class="fs-14" style="margin-bottom: 1px;">
                              Nama Driver
                            </div>
                            <div class="fs-16 label-input font-weight-bold">
                              {{ detail.driver_name }}
                            </div>
                          </div>
                        </v-col>
                        <v-col cols="4">
                          <div>
                            <div class="fs-14" style="margin-bottom: 1px;">
                              Nama Kendaraan
                            </div>
                            <div class="fs-16 label-input font-weight-bold">
                              {{ detail.vehicle_name }} - {{ detail.vehicle_number }}
                            </div>
                          </div>
                        </v-col>
                        <v-col cols="3">
                          <div>
                            <div class="fs-14" style="margin-bottom: 1px;">
                              Tanggal Pengiriman
                            </div>
                            <div class="fs-16 label-input font-weight-bold">
                              {{ detail.date | date }}
                            </div>
                          </div>
                        </v-col>
                        <v-col cols="3">
                          <div>
                            <div class="fs-14" style="margin-bottom: 1px;">
                              Status
                            </div>
                            <div class="fs-16 label-input font-weight-bold">
                              {{ detail.status == 'pengiriman' ? 'Pengiriman' : detail.status == 'diterima' ? 'Diterima Customer' : detail.status == 'Set Order' ? 'Menunggu Pengiriman' : '-' }}
                            </div>
                          </div>
                        </v-col>
                        <v-col cols="12">
                          <div>
                            <div class="fs-14" style="margin-bottom: 1px;">
                              Catatan
                            </div>
                            <div class="fs-16 label-input font-weight-bold">
                              {{ detail.note === '' ? '-' : detail.note }}
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card 
            flat
            style="border-radius: 6px;"
            v-if="!process.load && Object.keys(detail).length > 0"
            background-color="#fff" class="mt-3">
            <v-card-text>
              <ValidationObserver 
                ref="form">
                <v-form>
                  <v-card flat style="border-radius: 25px;" class="mt-0 mb-0" v-if="Object.keys(detail).length > 0">
                    <v-card-text class="pa-0">
                      <div class="fs-18 input-label font-weight-bold py-2 black--text">
                        Detail BPB
                      </div>
                    </v-card-text>
                  </v-card>
    
                  <div v-if="Object.keys(detail).length > 0">
    
                    <v-card flat style="border-radius: 6px; border: 1px solid #E7E7E7;" class="pb-7 mt-2 mb-5"  v-for="(items, indexs) in detail.bpb" :key="indexs">
                        <v-card-text>
                          <v-row>
                            <v-col class="pt-0">
                              <div class="fs-14" style="margin-bottom: 1px;">
                                No. BPB
                              </div>
                              <div class="fs-16 label-input font-weight-bold">
                                {{ items.bpb_number }}
                              </div>
                            </v-col>
    
                            <v-col class="pt-0">
                              <div class="fs-14" style="margin-bottom: 1px;">
                                Nama Customer
                              </div>
                              <div class="fs-16 label-input font-weight-bold">
                                {{ items.customer_name }}
                              </div>
                            </v-col>
    
                            <v-col class="pt-0">
                              <div class="fs-14" style="margin-bottom: 1px;">
                                No. Order
                              </div>
                              <div class="fs-16 label-input font-weight-bold">
                                {{ items.orders_number }}
                              </div>
                            </v-col>
    
                            <v-col class="pt-0" v-if="items.bpb_diterima_date !== undefined && items.bpb_diterima_date !== null">
                              <div class="fs-14" style="margin-bottom: 1px;">
                                Tanggal Barang Diterima
                              </div>
                              <div class="fs-16 label-input font-weight-bold">
                                {{ items.bpb_diterima_date | date }}
                              </div>
                            </v-col>

                            <!-- <v-col class="text-right">
                              <div class="text-right">
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      @click="exports(items.bpb_id); selected.item = items.bpb_id"
                                      :loading="process.export && selected.item === items.bpb_id"
                                      :disabled="process.export && selected.item === items.bpb_id"
                                      elevation="0"
                                      min-height="28"
                                      small
                                      min-width="28"
                                      color="#bd1112"
                                      class="text-capitalize px-0 mx-1"
                                      style="border-radius: 6px;"
                                      v-bind="attrs"
                                      v-on="on">
                                      <v-icon size="18" color="white">mdi-file-pdf-box</v-icon>
                                    </v-btn>
                                  </template>

                                  <span>
                                    Export Pdf
                                  </span>
                                </v-tooltip>
                              </div>
                            </v-col> -->
                          </v-row>
                          <!-- <div class="mb-2" v-if="detail.status !== 'diterima'">
                            <v-btn
                              @click="toDelete(items.bpb_id)"
                              min-width="28"
                              small
                              rounded
                              color="red"
                              elevation="0"
                              class="white--text text-capitalize mx-1"
                              style="font-weight: 600; border-radius: 6px;">
                              Hapus BPB
                            </v-btn>
                          </div> -->
                          <table width="100%" style="border: thin solid #E6EFF5;">
                            <thead>
                              <tr>
                                <!-- <th class="text-center black--text fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">Aksi</th> -->
                                <th class="text-left black--text fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">Nama Barang</th>
                                <th class="text-left black--text fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">No. SKU</th>
                                <th class="text-left black--text fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5; border-right: thin solid #E6EFF5;">{{ detail.status === 'Set Order' ? 'Qty yang akan dikirim' : 'Qty yang dikirim' }}</th>
                                <th class="text-left black--text fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5; border-right: thin solid #E6EFF5;">Qty Dus Muat</th>
                                <th class="text-left black--text fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Qty Dus Rusak</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(item, index) in items.detail" :key="index">
                                <!-- <td class="sticky-col one-col" style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 60px; min-width: 60px; max-width: 60px; padding: 8px 12px; text-align: center;">
                                  <v-tooltip 
                                    top>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        @click="toDelete(item.bpb_detail_id)"

                                        v-bind="attrs"
                                        v-on="on"

                                        min-width="28"
                                        small
                                        rounded
                                        color="red"
                                        elevation="0"
                                        class="white--text text-capitalize mx-1 px-0"
                                        style="font-weight: 600; border-radius: 6px;">
                                        <v-icon small>mdi-trash-can-outline</v-icon>
                                      </v-btn>
                                    </template>
                                    
                                    <span>Hapus</span>
                                  </v-tooltip>
                                </td> -->
                                <td class="text-left black--text label-input fs-14 pa-2" style="vertical-align: sub; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">{{ item.varian_name }}</td>
                                <td class="text-left black--text label-input fs-14 pa-2" style="vertical-align: sub; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">{{ item.varian_sku }}</td>
                                <td class="text-left black--text label-input fs-14 pa-2" style="vertical-align: sub; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">
                                  <div v-if="item.qty_pcs*1 > 0">
                                    {{ item.qty_pcs }} Pcs
                                  </div>
                                  <div v-if="item.qty_lusin*1 > 0">
                                    {{ item.qty_lusin }} Lusin
                                  </div>
                                  <div v-if="item.qty_dus*1 > 0">
                                    {{ item.qty_dus }} {{ (item.qty_in_dus*1) > 1 ? 'Dus' : 'Pcs' }}
                                  </div>
                                </td>
                                <td class="text-left black--text label-input fs-14 pa-2" style="vertical-align: sub; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">
                                  <div v-if="detail.is_muat === '1'">
                                    {{ item.qty_dus_muat }} {{ (item.qty_in_dus*1) > 1 ? 'Dus' : 'Pcs' }}
                                  </div>
                                  <div v-if="detail.is_muat === '0'">
                                    <ValidationProvider
                                      :name="`Qty Dus Muat ${item.varian_name}`"
                                      :rules="`required|min_value:0|max_value:${item.qty_dus}`" 
                                      v-slot="{ errors }">
                
                                      <v-currency-field
                                      
                                        filled
                                        rounded
                                        dense
                                        solo
                  
                                        color="#718EBF"
                                        placeholder="Qty Dus Muat"
                                        :suffix="item.qty_in_dus*1 > 1 ? 'Dus' : 'Pcs'"
                                        
                  
                                        v-model="item.qty_dus_muat"
                                        :error-messages="errors"
                                        required
                                        style="border-radius: 10px;">
                                      </v-currency-field>
                                    </ValidationProvider>
                                  </div>
                                </td>
                                <td class="text-left black--text label-input fs-14 pa-2" style="vertical-align: sub; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">
                                  <div v-if="detail.is_muat === '1'">
                                    {{ item.qty_dus_rusak }} Dus
                                  </div>
                                  <div v-if="detail.is_muat === '0'">
                                    <ValidationProvider
                                      :name="`Qty Dus Rusak ${item.varian_name}`"
                                      :rules="`required|min_value:0|max_value:${item.qty_dus}`" 
                                      v-slot="{ errors }">
                
                                      <v-currency-field
                                      
                                        filled
                                        rounded
                                        dense
                                        solo
                  
                                        color="#718EBF"
                                        placeholder="Qty Dus Rusak"
                                        suffix="Dus"
                                        
                  
                                        v-model="item.qty_dus_rusak"
                                        :error-messages="errors"
                                        required
                                        style="border-radius: 10px;">
                                      </v-currency-field>
                                    </ValidationProvider>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <div v-for="(item, index) in items.detail" :key="index">
                            <!-- {{ index+items.bpb_id }} -->
                            <!-- <table width="100%" style="border-bottom: thin solid #E6EFF5;">
                              <thead>
                                <tr>
                                  <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Nama Barang</th>
                                  <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">No. SKU</th>
                                  <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Qty</th>
                                  <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Qty Lusin</th>
                                  <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Qty Dus</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(item, index) in form.varian_arr" :key="index">
                                  <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_varian_name }}</td>
                                  <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_varian_sku }}</td>
                                  <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_qty_pcs_approved }}</td>
                                  <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_qty_lusin_approved }}</td>
                                  <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_qty_dus_approved }}</td>
                                </tr>
                              </tbody>
                            </table> -->
                            <!-- <v-card flat class="mb-5" style="background: #718ebf17; border-radius: 15px;">
                              <v-card-text>
                                <div class="fs-16 font-weight-bold label-input">
                                  {{ item.varian_name }}
                                </div>
                                <div>
                                  <span>Kode SKU</span>: <span>{{ item.varian_sku }}</span>
                                </div>
        
                                <v-row class="pt-3 pb-0">
                                  <v-col class="py-0" cols="12" md="4">
                                    <div 
                                      class="fs-15 label-input" v-if="detail.status === 'Set Order'">
                                      Qty yang akan dikirim
                                    </div>
                                    <div 
                                      class="fs-15 label-input" v-if="detail.status !== 'Set Order'">
                                      Qty yang dikirim
                                    </div>
                                  </v-col>
    
                                  <v-col class="py-0" cols="12" md="4"  v-if="detail.status === 'diterima' || detail.status == 'pengiriman terkonfirmasi'">
                                    <div 
                                      class="fs-15 label-input">
                                      Qty yang diterima
                                    </div>
                                  </v-col>
    
                                  <v-col class="py-0" cols="12" md="4"  v-if="detail.status === 'diterima' || detail.status == 'pengiriman terkonfirmasi'">
                                    <div 
                                      class="fs-15 label-input">
                                      Qty yang dikembalikan
                                    </div>
                                  </v-col>
                                </v-row>
        
                                <v-row v-if="item.qty_pcs*1 > 0">
        
                                  <v-col class="py-0" cols="12" md="4">
              
                                    <div class="fs-19 font-weight-bold label-input">
                                      {{ item.qty_pcs }} Pcs
                                    </div>
                                  </v-col>
                                  <v-col class="py-0" cols="12" md="4" v-if="detail.status === 'diterima' || detail.status == 'pengiriman terkonfirmasi'">
                                    
                                    <div class="fs-19 font-weight-bold label-input">
                                      {{ item.qty_pcs_diterima }} Pcs
                                    </div>
                                  </v-col>
                                  <v-col class="py-0" cols="12" md="4" v-if="detail.status === 'diterima' || detail.status == 'pengiriman terkonfirmasi'">
              
                                    <div class="fs-19 font-weight-bold label-input">
                                      {{ item.qty_pcs_return }} Pcs
                                    </div>
                                  </v-col>
                                </v-row>
        
                                <v-row v-if="item.qty_lusin*1 > 0">
        
                                  <v-col class="py-0" cols="12" md="4">
              
                                    <div class="fs-19 font-weight-bold label-input">
                                      {{ item.qty_lusin }} Lusin
                                    </div>
                                  </v-col>
                                  <v-col class="py-0" cols="12" md="4" v-if="detail.status === 'diterima' || detail.status == 'pengiriman terkonfirmasi'">
              
                                    <div class="fs-19 font-weight-bold label-input">
                                      {{ item.qty_lusin_diterima }} Lusin
                                    </div>
                                  </v-col>
                                  <v-col class="py-0" cols="12" md="4" v-if="detail.status === 'diterima' || detail.status == 'pengiriman terkonfirmasi'">
              
                                    <div class="fs-19 font-weight-bold label-input">
                                      {{ item.qty_lusin_return }} Lusin
                                    </div>
                                  </v-col>
                                </v-row>
        
                                <v-row v-if="item.qty_dus*1 > 0">
                                  <v-col class="py-0" cols="12" md="4">
                                    
                                    <div class="fs-19 font-weight-bold label-input">
                                      {{ item.qty_dus }} dus
                                    </div>
                                  </v-col>
                                  <v-col class="py-0" cols="12" md="4" v-if="detail.status === 'diterima' || detail.status == 'pengiriman terkonfirmasi'">
              
                                    <div class="fs-19 font-weight-bold label-input">
                                      {{ item.qty_dus_diterima }} Dus
                                    </div>
                                  </v-col>
                                  <v-col class="py-0" cols="12" md="4" v-if="detail.status === 'diterima' || detail.status == 'pengiriman terkonfirmasi'">
              
                                    <div class="fs-19 font-weight-bold label-input">
                                      {{ item.qty_dus_return }} Dus
                                    </div>
                                  </v-col>
                                </v-row>
        
                              </v-card-text>
                            </v-card> -->
                          </div>
      
                      </v-card-text>
                    </v-card>
                  </div>
                </v-form>
              </ValidationObserver>
    
              <v-row
                justify="end"
                class="pa-4 pr-1">
                <v-col 
                  cols="12"
                  md="12"
                  class="d-flex align-center justify-end py-0">
    
                  <v-btn 
                    :loading="process.form"
                    :disabled="process.form"
                    v-if="detail.is_muat === '0'"
                    @click="save()"
                    width="150"
                    height="45"
                    elevation="0"
                    color="#1814F3"
                    class="fs-16 white--text text-capitalize border-radius">
                    Simpan
                  </v-btn>
                  
                  <v-btn
                    to="/delivery/proses-muat"
                    color="red"
                    :disabled="process.form"
                    elevation="0"
                    width="140"
                    height="45"
                    class="body-2 white--text text-capitalize d-flex align-center ml-4 border-radius"
                    style="font-weight: 600;">
                  
                      Kembali
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import axios from "axios";
  import "moment/locale/id"
  export default {
    data () {
      return {
        approved_by: [],
        approved_reason: '',
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: false,
        modal: false,
        menu2: false,
        
        zoomed: false,
        zoomedTtd: false,
        imageAspectRatio: 1,
        imageAspectRatioTtd: 1,

        dialog: {
          status: false,
          snackbar: false,
          delete: false,
          fullscreen: false
        },
        status: '',

        detail: {},

        rejected_reason: '',

        form: {
          id: '',
          bpb_arr: []
        },
        category: [],
        branch: [],

        mobilephone: {
          name: '',
          id: ''
        },

        upload: {
          ttd: null,
          image_url: null
        },
        selected: {
          item: '',
          status: [],
          delete: [],
          row: []
        },

        process: {
          form: false,

          load: false,

          image_url: false,
          export: false,
          delete: false
        },
        
        message: {
          success: '',
          error: '',
          status: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        this.process.load = true
        let params = {
          id: this.$route.params.id
        }

        await get('admin/surat_jalan/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.form.bpb_arr = []
            this.detail = res.results.data
            res.results.data.bpb.map((item, index) => {
              this.form.bpb_arr.push({
                bpb_id: item.bpb_id,
                bpb_detail: item.detail
              })
            })

            this.form.bpb_arr.map((item, index) => {
              item.bpb_detail.map((items, indexs) => {
                items.bpb_detail_id = items.bpb_detail_id
                items.varian_name = items.varian_name
                items.varian_sku = items.varian_sku
                items.qty_pcs_diterima = items.qty_pcs_diterima
                items.qty_dus_diterima = items.qty_dus_diterima
                items.qty_lusin_diterima = items.qty_lusin_diterima
                items.qty_pcs_return = items.qty_pcs_return
                items.qty_dus_return = items.qty_dus_return
                items.qty_lusin_return = items.qty_lusin_return
                items.qty_dus_muat = items.qty_dus_muat
                items.qty_dus_rusak = items.qty_dus_rusak
              })
            })
          }
          this.process.load = false
        })
      },
      reset (index) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.rejected_reason = ''

        this.process.form = false

        this.message.error = ''
      },
      onImageLoad(e) {
        const img = e.target
        this.imageAspectRatio = img.naturalWidth / img.naturalHeight
      },
      onImageLoadAkta(e) {
        const img = e.target
        this.imageAspectRatioAkta = img.naturalWidth / img.naturalHeight
      },

      async save () {
        this.message.error = ''
        const isValid = await this.$refs.form.validate()
        if (isValid) {
        let bpb_array = []
        this.detail.bpb.map((item, index) => {
          item.detail.map((items, indexs) => {
            bpb_array.push({
              bpb_detail_id: items.bpb_detail_id,
              qty_dus_muat: items.qty_dus_muat,
              qty_dus_rusak: items.qty_dus_rusak
            })
          })
        })
        this.process.form = true
        let form = {
          id: this.detail.id,
          detail_array: bpb_array
        }

        let url = 'admin/surat_jalan/add_proses_muat'

        await post(url, {
          data: form
        }).then(response => {
          let res = response.data

          this.process.form = false

          if (res.status === 200) {

            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetchDetail()
          } else {
            this.message.error = res.message
          }
        })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }

        
      },
      async exports (id) {
        this.message.error = ''

        this.process.export = true

        let params = {
          bpb_id: id
        }

        await axios({
          url: `${process.env.VUE_APP_API_URL}admin/bpb/export_pdf`,
          method: 'GET',
          responseType: 'blob', // important,
          params: params,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response

          this.process.export = false
          console.log(res.headers)
          let disposition = res.headers['content-disposition']
          // console.log(disposition)
          var fileName = res.headers['content-disposition'].split('filename=\"')[1]
          let filename = ''

          if (disposition && disposition.indexOf('inline') !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) { 
              filename = matches[1].replace(/['"]/g, '');
            }
          }
          // console.log(filename)

          if (res.status === 200) {
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport pdf'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url

            link.setAttribute('download', filename)
            document.body.appendChild(link)

            link.click()
          } else {
            this.message.error = res.message
          }
        })
      },

      toDelete (id) {
        this.selected.delete = [id]

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post(`admin/bpb/lepas_surat_jalan`, {
          data: {
            id: this.selected.delete[0]
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetchDetail()
          } else {
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>


<style>
  /* ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background-color: #F5F5F5;
  }
  ::-webkit-scrollbar-track{
    background-color: #F5F5F5;
    border-radius: 10px;
  } */
  ::-webkit-scrollbar-thumb{
    border-radius: 10px;
    background-color: #718EBF;
  }
  table, th, td {
    /* border: 1px solid #ededed;
    border-collapse: collapse; */
    /* border: thin ridge black; */
    border-spacing: 4px;
    border-collapse: collapse;
  }

  .view {
    margin: auto;
    /* width: 100%; */
  }

  .wrapper { 
    overflow-y: auto; 
    height: calc(100vh - 390px); 
  } 

  .wrapper-none { 
    /* overflow-y: auto; 
    height: calc(100vh - 270px);  */
  } 

  .wrapper th { 
    position: sticky; 
    top: 0; 
    background-color: white !important;
  } 
  .sticky-col {
    position: -webkit-sticky;
    position: sticky;
    background-color: white !important;
  }

  .one-col {
    width: 60px;
    min-width: 60px;
    max-width: 60px;
    left: 0px;
  }

  .second-col {
    width: 150px;
    min-width: 150px;
    max-width: 150px;
    left: 150px;
  }

  .three-col {
    width: 150px;
    min-width: 150px;
    max-width: 150px;
    left: 300px;
  }

  .four-col {
    width: 200px;
    min-width: 200px;
    max-width: 200px;
    left: 450px;
  }

  tr:hover {background-color: #1976d236;}
  tr.selected {background-color: #1976d236;}
</style>